var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.value}},[(false)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":64,"color":_vm.progressColor}}):_vm._e(),(_vm.message != null)?_c('h1',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }